import { render, staticRenderFns } from "./ConsentTemplate.vue?vue&type=template&id=11c7ac4b&scoped=true&"
import script from "./ConsentTemplate.vue?vue&type=script&lang=ts&"
export * from "./ConsentTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./ConsentTemplate.vue?vue&type=style&index=0&id=11c7ac4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c7ac4b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
